module.exports = __webpack_public_path__ + "img/lg_ring_g_e_1_1@3x.3426ac26.png";